import { createSlice } from "@reduxjs/toolkit";

import { axiosGet } from "../../../api/axiosCalls";
import { setError } from "../errorSlice";
import { mapBrands } from "./maps";

const initialState = {
  isLoading: false,
  brandList: [],
  error: null,
};

const loadingFailed = (state, action) => {
  const { error } = action.payload;
  state.isLoading = false;
  state.error = error;
};

const brandSlice = createSlice({
  name: "brands",
  initialState,
  reducers: {
    setIsLoading(state) {
      state.isLoading = true;
    },
    getBrandsSuccess(state, action) {
      const { brands } = action.payload;
      state.brandList = brands;
      state.isLoading = false;
      state.error = null;
    },
    setFailure: loadingFailed,
  },
});

export const { setIsLoading, getBrandsSuccess, setFailure } =
  brandSlice.actions;

export default brandSlice.reducer;

export const fetchBrands = () => async (dispatch) => {
  try {
    dispatch(setIsLoading());
    const queryString = `/api/brands?filter[is-active]=true`;
    const response = await axiosGet(queryString);
    if (response.error) throw response.error;
    const mappedData = mapBrands(response.data);
    dispatch(getBrandsSuccess({ brands: mappedData }));
  } catch (err) {
    dispatch(setFailure({ error: err.toString() }));
    dispatch(setError({ error: err.toString(), source: "Brands" }));
  }
};
